import React, { useEffect, useState } from 'react'
import RouteModal from '../../../../Component/BasicComponents/Modal/RouteModal';
import CustomInput from '../../../../Component/BasicComponents/CustomInput';
import { Btn } from '../../../../AbstractElements';
import { useAddSubscriberTypes, useUpdateSubscriberType } from '../hooks/useSubscriber';
import RouteDropdown from '../../../../Component/BasicComponents/Dropdowns/RouteDropdown';
import { toast } from "react-toastify";

type ProductCardProps = {
    setIsModalOpen?: any;
    isModalOpen?: any;
    toggleModal?: any;
    title?: any;
    checkAddEditStatus?: any;
    setCheckAddEditStatus?: any;
    rowData?: any;
    data?: any;

};
const SubscriberTypeAddAndEditModal: React.FC<ProductCardProps> = ({ data,rowData, setIsModalOpen, isModalOpen, title, checkAddEditStatus, setCheckAddEditStatus }) => {
    const [modalValues, setModalValues] = useState<any>({
        TypeName: '',
        OutletTypeId: [] as { id: number; name: string }[],
    })
    // const { data } = useOutletTypesData({ enable: true });
    const { mutate } = useAddSubscriberTypes();
    const { mutate: updateMutate } = useUpdateSubscriberType();

    const handleClose = () => {
        setIsModalOpen(false);
        setCheckAddEditStatus('');
        setModalValues((prevState: any) => ({ ...prevState, OutletTypeId: [], TypeName: '' }))
    }

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        if (modalValues?.OutletTypeId?.length <= 0) {
            toast.warn("Please select outlet type.");
            return;
        }
        const body = {
            TypeName: modalValues?.TypeName,
            OutletTypeId: modalValues?.OutletTypeId?.map((itm: any) => Number(itm?.id)),
        };
        if (checkAddEditStatus === "Add") {
            mutate(body, {
                onSuccess: () => {
                    handleClose();
                },
            });
        } else {
            updateMutate(
                { id: Number(rowData?.SubscriberTypeId), body },
                {
                    onSuccess: () => {
                        handleClose();
                    },
                }
            );
        }
    };


    const handleOutletType = (selectedValues: string[] | number[]) => {
        let selectedData = selectedValues.map((id) =>
            data?.data.find((unit: any) => Number(unit.id) === Number(id))
        );
        setModalValues((prevState: any) => ({ ...prevState, OutletTypeId: selectedData.filter(Boolean) }));
    };

    useEffect(() => {
        if (checkAddEditStatus === 'Edit') {
            console.log('row Data of subscriber type',rowData)
            let OutletTypeId = Object.values(rowData?.OutletTypeIds||{})?.map(Number)
            let formattedData = data?.data?.filter((i: any) => OutletTypeId?.includes(i?.id))
            setModalValues((prevState: any) => ({ ...prevState, OutletTypeId: formattedData||[], TypeName: rowData?.TypeName }))
        }
    }, [checkAddEditStatus])


    return (
        <RouteModal
            isOpen={isModalOpen}
            toggle={() => { setIsModalOpen(!isModalOpen);setModalValues((prevState: any) => ({ ...prevState, OutletTypeId: [], TypeName: '' })); }}
            title={title}
            // title="Add MTP"
            size="md"
            content={
                <form onSubmit={handleSubmit}>
                    <div className="row mb-0">

                        <CustomInput
                            placeholder="Type Name"
                            disabled={false}
                            onChange={(e: any) => { setModalValues((prevState: any) => ({ ...prevState, TypeName: e.target.value })); }}
                            value={modalValues?.TypeName}
                            required={true}
                            label="Type Name*"
                            style={{
                                border: "1px solid #EDEDED",
                                borderRadius: "4px",
                                padding: "10px",
                                fontSize: "14px",
                                backgroundColor: "#fff",
                            }}
                        />

                        <RouteDropdown
                            isMulti={true}
                            options={data?.data || []}
                            value={modalValues.OutletTypeId.map((val: any) => val.id.toString())}
                            onChange={(value: any) => {
                                handleOutletType(value)
                            }}
                            DropdownHeading="Outlet Types*"
                        />

                        <div style={{ height: 20 }} />
                        <div className="d-flex justify-content-start gap-2">
                            <Btn
                                style={{ backgroundColor: "#43B9B2", color: "white" }}
                                type="submit"
                            >
                                {checkAddEditStatus === 'Add' ? 'Submit' : 'Update'}
                            </Btn>
                            <Btn
                                style={{
                                    backgroundColor: "#F9FAFC",
                                    color: "#000",
                                    border: "1px solid #E0E0E0",
                                }}
                                type="button"
                                onClick={() => { setIsModalOpen(false); setCheckAddEditStatus(''); setModalValues((prevState: any) => ({ ...prevState, OutletTypeId: [], TypeName: '' })); }}
                            >
                                Cancel
                            </Btn>
                        </div>



                    </div>
                </form>
            }
        />
    )
}

export default SubscriberTypeAddAndEditModal